// Se ->
// 	instance // for main form
// 		-> api // for component 1
// 		-> api // for component 2
// 	instance // for se results
// 		-> api // for component 1
// 		-> api // for component 2

import testVersionsCompatibility from './compatibility/test-versions-compatibility';
import {testApiVersion, testApiVersionGroup} from './compatibility/test-api-version';

const getPromises = {}; // by se id, to resolve once se is inited
const instances = {};

const runGetPromises = ({id, instance}) => {
	const instanceGetPromises = getPromises[id];
	if(instanceGetPromises){
		instanceGetPromises.forEach(resolve => resolve(instance));
	}
}

const getApi = ({instance, versions}) => {
	const getApiByVersion = instance.api[versions.api];
	const api = getApiByVersion(instance);
	return {
		apiVersion: versions.api,
		testApiVersion: config => testApiVersion({config, versions}),
		testApiVersionGroup: config => testApiVersionGroup({config, versions}),
		...api,
	}
}

const preInitModule = (instance, preInitFn) => {
	if(!preInitFn){
		return undefined;
	}
	const {events, eventNames, init} = preInitFn(instance);
	const data = {
		api: {},
		init,
	}
	if(events){
		data.api.on = events.on;
		data.api.once = events.once;
		data.api.off = events.off;
		data.api.batch = events.batch;
		data.api.ignore = events.ignore;
	}
	if(eventNames){
		data.api.events = eventNames;
	}
	return data;
}
const initModule = (_module, preInitResult) => {
	if(!_module || !preInitResult){
		return undefined;
	}
	return {
		..._module,
		...preInitResult.init(),
	}
}

const getSe = ({store, server, url = {}, cookies = {}, api}) => {

	const init = ({id, engineId, engine, season, type, versions, requestOptions, fields, fieldCounters, criteriaCounters, counterBy, adultAge, defaultParticipantAges, modifySeRequest}) => {
		
		if(instances[id]){
			console.warn(`Se ${id} is already initialized`);
			return instances[id];
		}

		testVersionsCompatibility(versions);

		const getApi = ({versions}) => get({id, versions});
	
		// prepare instance
		const instance = instances[id] = {
			options: {
				id, 
				engineId, 
				engine,
				season,
				type, 
				versions, 
				requestOptions,
				fields, 
				fieldCounters,
				criteriaCounters,
				counterBy, // "prestId", "liheId" [default], "productId"
				adultAge,
				defaultParticipantAges,
				modifySeRequest,
			},
			api,
			getApi,
		}

		// pre init modules, because init itself requires pre-ini api
		const preInitStore = preInitModule(instance, store[versions.store]);
		const preInitServer = preInitModule(instance, server[versions.server]);
		const preInitUrl = preInitModule(instance, url[versions.url]);
		const preInitCookies = preInitModule(instance, cookies[versions.cookies]);

		// set pre-init api
		instance.store = preInitStore && preInitStore.api;
		instance.server = preInitServer && preInitServer.api;
		instance.url = preInitUrl && preInitUrl.api;
		instance.cookies = preInitCookies && preInitCookies.api;

		// init modules
		instance.store = initModule(instance.store, preInitStore);
		instance.server = initModule(instance.server, preInitServer);
		instance.url = initModule(instance.url, preInitUrl);
		instance.cookies = initModule(instance.cookies, preInitCookies);

		runGetPromises({id, instance});
		
		return {getApi};
	}

	const get = ({id, versions}) => {
		return new Promise((resolve, reject) => {
			const instance = instances[id];
			if(instance){
				testVersionsCompatibility({
					...instance.options.versions,
					...versions,
				});
				const api = getApi({instance, versions});
				resolve(api);
			}else{
				getPromises[id] = getPromises[id] || [];
				getPromises[id].push(instance => {
					testVersionsCompatibility({
						...instance.options.versions,
						...versions,
					});
					const api = getApi({instance, versions});
					resolve(api);
				});
			}
		});
	}

	const Se = {
		init,
		get,
	}

	return Se;
}

export default getSe;